import { State } from "./types";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  nbr: 0,
};

export { initialState };
